import React, { useState } from 'react'
import './CyberButton.css'

const CLIP = 'polygon(0 0, 88% 0, 100% 28%, 100% 100%, 12% 100%, 0 72%)'

export default function CyberButton({ onClick, children, active = false, style = {} }) {
  const [pressed, setPressed] = useState(false)

  const handleClick = (e) => {
    setPressed(true)
    setTimeout(() => setPressed(false), 450)
    onClick && onClick(e)
  }

  const wrapperClass = [
    'cyber-btn-wrapper',
    active ? 'cyber-active' : '',
    pressed ? 'cyber-pressed' : '',
  ].filter(Boolean).join(' ')

  const innerClass = [
    'cyber-btn-inner',
    pressed ? 'cyber-inner-pressed' : (active ? 'cyber-inner-active' : ''),
  ].filter(Boolean).join(' ')

  return (
    <div
      onClick={handleClick}
      className={wrapperClass}
      style={{
        position: 'relative',
        padding: '2px',
        background: 'linear-gradient(90deg, #00e5ff, #d000ff)',
        clipPath: CLIP,
        cursor: 'pointer',
        display: 'inline-block',
        ...style,
      }}
    >
      <span
        className={innerClass}
        style={{
          display: 'block',
          padding: '10px 32px',
          color: '#fff',
          fontWeight: 600,
          letterSpacing: '0.5px',
          fontSize: 13,
          clipPath: CLIP,
          userSelect: 'none',
          whiteSpace: 'nowrap',
        }}
      >
        {children}
      </span>
    </div>
  )
}
